import styled from 'react-emotion';

const Container = styled('div')`
  margin-left: -4px;
`;

export default Container;
